// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","imgwhite":"footer_imgwhite__yu+F9","linkfooter":"footer_linkfooter__bB4pd"};